import React, { memo, useEffect } from "react";
import { createPortal } from "react-dom";
import DroplistElement from "./droplist/index";
import { CloseIcon } from "@/componentsUI/Icon";
import { useVipInfo } from "@/store/PersonalCenter";
import styles from "./style/userDropList.module.less";
import { useGlobalOpenUserCenter } from "@/store/commonStore";
import { useLocation } from "react-router";
import { getAvatarUrl } from "@/utils/avatar";
import { getMobileCenteredShellPortalRoot } from "@/layout/components/mobileCenteredShell/portal";
import AvatarUI from "@/componentsUI/Avatar";

interface UserDropListProps {
  hasBonusRedDot: boolean;
  onBonusRedDotSeen: () => void;
}

const UserDropList = ({ hasBonusRedDot, onBonusRedDotSeen }: UserDropListProps) => {
  const { data } = useVipInfo(false);
  const [visibleDraw, setVisibleDraw] = useGlobalOpenUserCenter();
  const { pathname } = useLocation();
  const avatarSeed = data?.usrId ?? data?.userName;
  const avatarUrl = avatarSeed ? getAvatarUrl(avatarSeed, 64) : undefined;

  useEffect(() => {
    if (pathname) {
      setVisibleDraw(false);
    }
  }, [pathname]);

  const changeVisible = (event) => {
    event.stopPropagation();
    setVisibleDraw(true);
  };

  const handleClose = () => {
    setVisibleDraw(false);
  };

  const mobileUserCenterPanel = visibleDraw ? (
    <div className={styles.mobileUserCenterPanel} role="dialog" aria-modal="true">
      <button
        type="button"
        className={styles.mobileUserCenterMask}
        aria-label="Close user center"
        onClick={() => setVisibleDraw(false)}
      />
      <div className={styles.mobileUserCenterContainer}>
        <CloseIcon
          className={`svg-icon ${styles.closeIcon}`}
          onClick={() => setVisibleDraw(false)}
        />
        <DroplistElement
          handleColes={() => setVisibleDraw(false)}
          hasBonusRedDot={hasBonusRedDot}
          onBonusRedDotSeen={onBonusRedDotSeen}
        />
      </div>
    </div>
  ) : null;

  return (
    <>
      <div className={styles.userCenterTrigger} onClick={changeVisible}>
        <div
          className={styles.myAvatar}
          data-level-text={data?.level === undefined ? undefined : `V${data.level}`}
          data-red-dot={hasBonusRedDot ? "true" : undefined}
        >
          <AvatarUI className={styles.avatarTrigger}>
            {avatarUrl && <img alt={""} src={avatarUrl} />}
          </AvatarUI>
        </div>
      </div>

      {mobileUserCenterPanel &&
        createPortal(
          mobileUserCenterPanel,
          getMobileCenteredShellPortalRoot() || document.body
        )}
    </>
  );
};

export default memo(UserDropList);
